console.log(process.env.NODE_ENV);
import Axios from 'axios';
import Vue from 'vue'
import router from './../router'
let urlObject = {
    test: '',
    // development: 'http://yapi.dgj28.com/v1/app/',
    // production: 'http://yapi.dgj28.com/v1/app/'
    // development: 'http://ysfapi.yftq.jchorn.com/v1/app/',
    // production: 'http://ysfapi.yftq.jchorn.com/v1/app/'
    // ysfapi.yftq.jchorn.com
    development: 'https://api.yangshif.com/v1/app/',
    production: 'https://api.yangshif.com/v1/app/'
}
const baseURL = urlObject[process.env.NODE_ENV];
// export const imgUrl = 'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/'
export const imgUrl = 'https://logistics-cdn.oss-cn-shenzhen.aliyuncs.com/'

const axios = Axios.create({
    withCredentials: false,
    baseURL
});
axios.interceptors.request.use(function(config) {

    let user = JSON.parse(localStorage.getItem('userMessage') || '{}');
    config.headers['X-Access-Token'] = user.token;
    return config;
}, function(error) {
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    // 对响应错误做点什么
    const { status, data } = error.response;
    switch (status) {
        case 401:
            localStorage.removeItem('userMessage');
            router.push('/home');
            Vue.prototype.$eventBus.$emit('changeUserInfo', {})
            return Promise.reject(data);
            break;
        default:
            return Promise.reject(data);
    }
});
/***
 * get请求
 * 第一个参数路径，第二个参数是参数
 * 此处是字符串拼接在url后面
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            if (res.status && res.status == 200) {
                resolve(res.data.result);
            } else {
                reject(res.error.message)
            }
        }).catch(err => {
            console.log(err);
            reject(err.error)
        })
    });
}

export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                if (res.status && res.status == 200) {
                    resolve(res.data.result);
                } else {
                    reject(res.error.message)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err.error.message)
            })
    });
}
export function $delete(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, params)
            .then(res => {
                if (res.status && res.status == 200) {
                    resolve(res.data.result);
                } else {
                    reject(res.error.message)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err.error.message)
            })
    });
}
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(res => {
                if (res.status && res.status == 200) {
                    resolve(res.data.result);
                } else {
                    reject(res.error.message)
                }
            })
            .catch(err => {
                reject(err.error.message)
            })
    });
}
export default {
    get,
    post,
    put,
    $delete,
    imgUrl,
};


// WEBPACK FOOTER //
// ./src/utils/http.js